import React from 'react';
import { Link } from 'react-router-dom';
// Constants
import {
  CompanyTagLine,
  CompanyName,
  ContactEmailAddress,
} from '../../utils/Constants';
// Components
import FooterSocialCTA from './FooterSocialCTA';
// Images
import SammiSmithLogo from '../../assets/images/logos/mistress-sammi-smith-pink-logo.png';
// Data
import { FooterLinksArray } from '../../utils/data/FooterData';
import { MainServicesArray } from '../../utils/data/CompanyData';

function FooterComponent() {
  return (
    <footer className='grid bg-colour4 dark:bg-colour4 text-colour3 dark:text-colour3 w-full overflow-hidden font-poppins'>
      <div className='grid w-full py-6 md:py-12 px-6 md:px-20'>
        <div className='grid lg:grid-cols-3 mx-auto gap-6 bg-colour5 dark:bg-colour1 px-2 md:px-10 py-8 w-full'>
          {/* Logo section */}
          <section className='grid h-fit my-auto gap-4 py-2 w-full'>
            <div className='grid items-center justify-center'>
              <img
                src={SammiSmithLogo}
                alt={`${CompanyName} footer logo`}
                className='min-w-6 w-full'
              />
            </div>
            <div className='text-center'>
              <p className='text-sm'>{CompanyTagLine}</p>
            </div>
            <FooterSocialCTA />
          </section>

          {/* Footer links */}
          <section className='grid grid-cols-2 px-2 gap-2 w-full'>
            <div className='grid grid-rows-reg w-full lg:justify-center text-center'>
              <div className='text-left font-semibold w-full'>
                <h6>Quick Links</h6>
                <div className='border-b-2 border-solid border-colour4 pt-2 mb-2'></div>
              </div>
              <ul className='text-left w-full'>
                {FooterLinksArray.map((link, index) => {
                  return (
                    <li key={index}>
                      <Link
                        to={link.route}
                        aria-label={`${link.name} page navigation tab`}
                        className={`text-sm md:text-base`}
                        onClick={() => {
                          window.scroll(0, 0);
                        }}
                        aria-current={({ isActive }) =>
                          isActive ? 'page' : undefined
                        }
                      >
                        {link.name}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>

            <div className='grid grid-rows-reg justify-center text-center'>
              <div className='text-left font-semibold'>
                <h6>Services</h6>
                <div className='border-b-2 border-solid border-colour4 pt-2 mb-2'></div>
              </div>
              <ul className='text-left'>
                {MainServicesArray.map((service) => {
                  return (
                    <li key={service.label} className={`text-sm md:text-base`}>
                      {service.label}
                    </li>
                  );
                })}
              </ul>
            </div>
          </section>

          {/* Social media links */}
          <section className='grid grid-rows-reg gap-2 w-fit px-2'>
            <div className='text-left'>
              <h6>Contact Info</h6>
              <div className='border-b-2 border-solid border-colour4 pt-2 mb-2'></div>
            </div>

            <section className='grid gap-1 h-fit'>
              <p className='overflow-hidden'>
                <a
                  href={`mailto:${ContactEmailAddress}`}
                  aria-label={`Email ${CompanyName}`}
                >
                  <span className='font-semibold'>Email: </span>
                  {ContactEmailAddress}
                </a>
              </p>
      
            </section>
          </section>
        </div>
      </div>
    </footer>
  );
}

export default FooterComponent;
